module.exports = __webpack_public_path__ + "static/img/xtsjst1.c9e37df7.png";